import cx from 'classnames';
import PropTypes from 'prop-types';
import { CloseIcon } from '@ring-icons';
import { Cell } from '@amzn/ring-react-components/csr/components/Cell';
import { Button } from '@amzn/ring-react-components/csr/components/Button';


import './Banner.less';

function Banner({ children, buttonText, className, handleButton, handleClose, visible, sessionKey, clearKey, handleClearKey }) {
  const closedBanner = JSON.parse(sessionStorage.getItem(`${sessionKey}-banner-closed`)) === true;

  if (closedBanner && clearKey) {
    sessionStorage.removeItem(`${sessionKey}-banner-closed`);
    handleClearKey();
  }

  if (closedBanner && visible) {
    handleClose();
  }

  const onHandleClose = () => {
    sessionStorage.setItem(`${sessionKey}-banner-closed`, true);
    handleClose();
    return null;
  };

  return (
    visible && (
      <Cell
        hidden={!visible}
        data-testid="banner"
        className={cx('banner', className)}
        title={children}
        rightBlock={
          <>
            <Button color="negative" size="s" variant="filled" onClick={handleButton}>
              {buttonText}
            </Button>
            <CloseIcon height="24" width="24" onClick={onHandleClose} data-testid={`${sessionKey}-banner-close-icon`} />
          </>
        }
      ></Cell>
    )
  );
}

Banner.propTypes = {
  children: PropTypes.node,
  buttonText: PropTypes.string,
  className: PropTypes.string,
  handleButton: PropTypes.func,
  handleClose: PropTypes.func,
  visible: PropTypes.bool,
  sessionKey: PropTypes.string,
  clearKey: PropTypes.bool,
  handleClearKey: PropTypes.func,
};

export default Banner;
